import { useEffect } from 'react'
import { toast } from 'sonner'
import { useUIStore } from '@/stores/ui-store'

/**
 * Mounted at the root layout — subscribes to `useUIStore().permissionDenial`
 * and raises a sonner toast whenever a 403 is captured by api.ts.
 *
 * Per RBAC Module spec #10 §3.6.
 */
export function PermissionDeniedToast() {
  const denial = useUIStore((s) => s.permissionDenial)
  const dismiss = useUIStore((s) => s.dismissPermissionDenied)

  useEffect(() => {
    if (!denial) return

    const required = denial.requiredPermission
    const description = required
      ? `Ask your administrator to grant the \`${required}\` permission.`
      : denial.message

    toast.error('Action not allowed', {
      id: denial.dedupKey,
      description,
      duration: 5000
    })

    // Clear the slice after raising so a subsequent identical denial within the
    // dedup window can flow through if the user later moves past it.
    const t = setTimeout(() => dismiss(), 100)
    return () => clearTimeout(t)
  }, [denial, dismiss])

  return null
}
